import { useState } from 'react';
import { BellRing, Loader2, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function AdminBroadcast() {
  const [form, setForm] = useState({ title: '', body: '', url: '/app' });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post('/admin/notifications/broadcast', form);
      toast.success(`Notificación enviada a ${data.sent} miembros (campana + push).`);
      setForm({ title: '', body: '', url: '/app' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo enviar.');
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm outline-none transition-all placeholder:text-slate-400 focus:border-cnib-blue focus:ring-2 focus:ring-cnib-blue/15';

  return (
    <div className="mx-auto max-w-2xl space-y-6" data-testid="admin-broadcast-page">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">Comunicación</p>
        <h1 className="mt-1 flex items-center gap-2 font-heading text-2xl font-extrabold text-slate-900 sm:text-3xl">
          <BellRing className="h-7 w-7 text-cnib-blue" /> Notificar a la red
        </h1>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5 rounded-2xl border border-slate-200 bg-white p-6">
        <p className="text-sm text-slate-500">
          El mensaje llega a la campana de notificaciones de todos los socios y administradores, y como push a quienes
          la activaron en sus dispositivos.
        </p>
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-slate-700">Título *</label>
          <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required minLength={3} className={inputCls} placeholder="Ej. Asamblea general ordinaria — 15 de noviembre" data-testid="broadcast-title-input" />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-slate-700">Mensaje *</label>
          <textarea value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} required minLength={3} rows={4} className={inputCls} placeholder="Detalle del anuncio…" data-testid="broadcast-body-input" />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-slate-700">Destino al abrir</label>
          <select value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })} className={inputCls} data-testid="broadcast-url-select">
            <option value="/app">Panel del socio</option>
            <option value="/app/feed">Feed profesional</option>
            <option value="/app/propiedades">Mis propiedades</option>
            <option value="/app/cuotas">Mis cuotas</option>
            <option value="/noticias">Noticias del portal</option>
          </select>
        </div>
        <button type="submit" disabled={sending} data-testid="broadcast-send-button" className="flex items-center gap-2 rounded-full bg-orange-500 px-7 py-3 text-sm font-bold text-white transition-colors hover:bg-orange-600 disabled:opacity-60">
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          Enviar a toda la red
        </button>
      </form>
    </div>
  );
}
